var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoggedIn || _vm.isActive || _vm.hasKeptItems
    ? _c(
        "div",
        {
          staticClass: "kept-items-toggle",
          class: { "kept-items-toggle--guest": !_vm.isLoggedIn }
        },
        [
          _c(
            "div",
            {
              staticClass: "kept-items-toggle__label",
              attrs: {
                role: _vm.isLoggedIn ? null : "button",
                tabindex: _vm.isLoggedIn ? null : 0,
                "aria-label": _vm.isLoggedIn
                  ? null
                  : _vm.$translate("Bigtex5::Template.keptItemsGuestTeaserAria")
              },
              on: {
                click: _vm.onLabelClick,
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.onLabelClick($event)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.onLabelClick($event)
                  }
                ]
              }
            },
            [
              _c("span", { staticClass: "kept-items-toggle__header" }, [
                _c(
                  "button",
                  {
                    staticClass: "kept-items-toggle__info",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$translate(
                        "Bigtex5::Template.keptItemsInfoTitle"
                      )
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.openSizeAssistant($event)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-info-circle" })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "kept-items-toggle__title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$translate("Bigtex5::Template.keptItemsToggleTitle")
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "kept-items-toggle__badge" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$translate("Bigtex5::Template.keptItemsToggleBadge")
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                !_vm.isLoggedIn
                  ? _c("i", {
                      staticClass: "fa fa-lock kept-items-toggle__lock",
                      attrs: {
                        title: _vm.$translate(
                          "Bigtex5::Template.keptItemsGuestTeaserAria"
                        )
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "kept-items-toggle__switch" }, [
                _c("input", {
                  staticClass: "kept-items-toggle__checkbox",
                  attrs: { type: "checkbox", disabled: !_vm.isLoggedIn },
                  domProps: { checked: _vm.isActive },
                  on: { change: _vm.toggleFilter }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "kept-items-toggle__slider" })
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }